import { call, select, put, takeLatest } from 'redux-saga/effects';
import _get from 'lodash/get';
import * as actions from '../actions';
import { REMOVE_CAR_REQUEST } from '../types';
import { removeCarRequestApi } from '../api';

export function* removeCarRequestSaga() {
  const { removeCarSuccess, removeCarFailure } = actions;
  try {
    const {
      Data: { rn, csrfToken, locale },
      root: {
        removeCar: {
          newOwnerInformation: { email, firstName, lastName },
        },
      },
    } = yield select();

    const payload = {
      rn,
      locale,
      newOwnerInformation: email
        ? {
            firstName,
            lastName,
            email,
          }
        : null,
    };

    const {
      data: { message, success },
    } = yield call(removeCarRequestApi, csrfToken, payload);

    if (!success) {
      yield put(removeCarFailure(message));
    } else {
      yield put(removeCarSuccess());
    }
  } catch (e) {
    yield put(removeCarFailure(_get(e, 'response.data.message')));
  }
}

const removeCarSaga = [takeLatest(REMOVE_CAR_REQUEST, removeCarRequestSaga)];

export default removeCarSaga;
